import { OIDC, OKTA_SCOPES } from "./OktaUtility";

export const restoreOktaSession = async (props) => {
  const {
    oktaAuth,
    sessionToken,
    redirectUrl,
    callback,
    sessionOnly = false,
  } = props;
  try {
    const idToken = await oktaAuth.tokenManager.get("idToken");
    if (!sessionOnly && !idToken) {
      const isSessionExist = await oktaAuth.session.exists();
      if (isSessionExist) {
        const res = await oktaAuth.token.getWithoutPrompt({
          ...(sessionToken && { sessionToken: sessionToken }),
          scopes: OKTA_SCOPES,
        });
        oktaAuth.tokenManager.setTokens(res.tokens);
        if (redirectUrl || sessionToken) {
          window.location.href = `${window.location.origin}${
            redirectUrl ? window.atob(redirectUrl) : ""
          }`;
        }
        callback && callback(true);
      } else {
        callback && callback(false);
      }
    } else {
      const [idToken, accessToken] = await Promise.all([
        OIDC.tokenManager.get("idToken"),
        OIDC.tokenManager.get("accessToken"),
      ]);

      oktaAuth.tokenManager.setTokens({
        idToken,
        accessToken,
      });
    }
  } catch (e) {
    console.log("Silent renew failed", e);
  }
};

// check okta storage available in authstate.
export const getOKTAStorage = () => {
  const oktaTokens = OIDC.authStateManager.getAuthState();
  if (oktaTokens?.accessToken && oktaTokens?.idToken) {
    return oktaTokens;
  }
  return false;
};
